module.exports = __webpack_public_path__ + "img/Bermuda.8da8375d.svg";